import { Send, X } from 'lucide-react';
import { useState } from 'react';
import Translate from '../shared/Translate';
import WsContainers from '../shared/WsContainers';
import { errorLogEnabled } from '../shared/Utils';

const SendSms = ({
  recipients,
  setRecipients,
  setProvidedNumber,
  message,
  setMessage,
  smsGateway,
  setSmsGateway,
  expanded,
  toggleSection,
  settings,
  credentials,
}) => {
  const [sending, setSending] = useState(false)
  const [sendError, setSendError] = useState(null)

  const handleSendSms = () => {
    setSending(true)
    setSendError(null)
    WsContainers.action({
      _class: 'com.optimsys.costra.optimcall.pipedrive.sms.SendSms',
      credentials: credentials,
      recipients: recipients,
      message: message,
      deviceId: smsGateway,
    }).then(() => {
      setProvidedNumber('')
      setMessage('')
      toggleSection()
    }).catch((error) => {
      errorLogEnabled && console.error('Error on sending SMS:', error)
      setSendError(Translate.get('main.sms.error'))
    }).finally(() => {
      setSending(false)
    })
  };

  let sectionBody = expanded && (
     <div 
      className="comm-form-wrapper"
      onClick={event => {
        event.stopPropagation()
        toggleSection()
      }}
    >
      <div 
        className="comm-form"
        onClick={event => event.stopPropagation()}
      >
        <div className='comm-form-close'>
          <X
            size={16}
            onClick={toggleSection}
          />
        </div>
        <div className="form-group">
          <label className="form-label">{Translate.get('main.sms.recipients')}</label>
          <input
            type="text"
            className="form-input"
            value={recipients}
            onChange={(e) => {
              setRecipients(e.target.value);
            }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">{Translate.get('main.sms.message')}</label>
          <textarea
            className="form-textarea sms-textarea"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </div>

        <div className="form-group">
          <label className="form-label">{Translate.get('main.sms.gateway')}</label>
          <select
            className="form-select"
            value={smsGateway}
            onChange={(e) => setSmsGateway(e.target.value)}
            disabled={Object.entries(settings?.smsSettings?.smsGatewaySettings || []).length === 0}
          >
            {Object.entries(settings?.smsSettings?.smsGatewaySettings || []).map(([key, value]) => {
              if (value.isEnabled) {
                return (
                  <option key={key} value={key}>
                    {value.displayName || key}
                  </option>
                );
              }
              return null;
            })}
          </select>
        </div>

        {sendError && <div className="sms-error">{sendError}</div>}
        <button
          className="sms-button"
          onClick={handleSendSms}
          disabled={!recipients || !message || !smsGateway || sending}
        >
          <Send size={18} />
          <span>{sending ? Translate.get('main.sms.sending') : Translate.get('main.sms.button')}</span>
        </button>
      </div>
    </div>
  )

  return sectionBody;
};

export default SendSms;
